import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ProgressColoringProvider } from "@webapp/configuration/providers/progress-coloring.provider";
import { CustomFieldsActionsProvider } from "@webapp/custom-fields/providers/custom-fields.provider";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { PlanningSessionsServiceProvider } from "@webapp/sessions/providers/sessions.provider";
import { SessionsModule } from "@webapp/sessions/sessions.module";
import { UiAvatarModule } from "@webapp/ui/avatar/avatar.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiCheckboxModule } from "@webapp/ui/checkbox/checkbox.module";
import { UiFormModule } from "@webapp/ui/form/form.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiModalModule } from "@webapp/ui/modal/modal.module";
import { UiRadioModule } from "@webapp/ui/radio/radio.module";
import { UiSelectModule } from "@webapp/ui/select/select.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { UiTypographyModule } from "@webapp/ui/typography/typography.module";
import { CloneOrMoveResourceService } from "./clone-move-resource.service";
import { CloneKrModalComponent } from "./clone-okrs/modals/clone-kr-modal/clone-kr-modal.component";
import { CloneOkrModalComponent } from "./clone-okrs/modals/clone-okr-modal/clone-okr-modal.component";
import { ConfirmCloneOrMoveComponent } from "./confirm-clone-or-move/confirm-clone-or-move.component";
import { MoveOkrModalComponent } from "./move-okrs/move-okr-modal.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizationModule,
    UiSelectModule,
    UiFormModule,
    UiRadioModule,
    UiInputModule,
    UiIconModule,
    UiAvatarModule,
    UiCheckboxModule,
    UiTooltipModule,
    UiButtonModule,
    SessionsModule,
    UiTypographyModule,
    UiModalModule,
  ],
  declarations: [CloneOkrModalComponent, CloneKrModalComponent, ConfirmCloneOrMoveComponent, MoveOkrModalComponent],
  providers: [CloneOrMoveResourceService, PlanningSessionsServiceProvider, CustomFieldsActionsProvider, ProgressColoringProvider],
})
export class CloneMoveOkrModule {}
